"use client";

import { useState } from "react";
import { LogoutIcon } from "@/components/icons";
import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { useLogout } from "../data/auth.mutations";

type LogoutButtonProps = {
  className?: string;
  iconOnly?: boolean;
};

export function LogoutButton({ className, iconOnly = false }: LogoutButtonProps) {
  const logoutMutation = useLogout();
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  function confirmLogout() {
    logoutMutation.mutate(undefined, {
      onSuccess: () => setIsConfirmationOpen(false),
    });
  }

  return (
    <>
      <Button
        className={className}
        variant="ghost"
        size={iconOnly ? "icon" : "md"}
        aria-label={iconOnly ? "Log out" : undefined}
        title={iconOnly ? "Log out" : undefined}
        disabled={logoutMutation.isPending}
        onClick={() => setIsConfirmationOpen(true)}
      >
        <LogoutIcon />
        {iconOnly ? null : <span data-slot="logout-label">Log out</span>}
      </Button>

      <Dialog open={isConfirmationOpen} onOpenChange={setIsConfirmationOpen}>
        <DialogContent size="compact">
          <DialogHeader>
            <DialogTitle>Log out?</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            You’ll need to sign in again to access your dashboard.
          </DialogDescription>
          <DialogFooter>
            <Button variant="secondary" disabled={logoutMutation.isPending} onClick={() => setIsConfirmationOpen(false)} autoFocus>
              Cancel
            </Button>
            <Button variant="primary" disabled={logoutMutation.isPending} onClick={confirmLogout}>
              {logoutMutation.isPending ? "Logging out…" : "Log out"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
